import { render, staticRenderFns } from "./beneficiaryUsers.vue?vue&type=template&id=2247546d&"
import script from "./beneficiaryUsers.vue?vue&type=script&lang=js&"
export * from "./beneficiaryUsers.vue?vue&type=script&lang=js&"
import style0 from "./beneficiaryUsers.vue?vue&type=style&index=0&id=2247546d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports